module.exports = __webpack_public_path__ + "static/img/level46.f16d0cc0.png";